import { IconDotsVertical } from '@tabler/icons-react';
import { ActionIcon } from '@zorro/design-system/v2/ActionIcon';
import { Menu } from '@zorro/design-system/v2/Menu';
import { useState } from 'react';

export type EditSubMenuItem = {
  title: string;
  onClick: () => void;
  disabled?: boolean;
};

export type EditSubMenuProps = {
  items: EditSubMenuItem[];
};

export const EditSubMenu = ({ items }: EditSubMenuProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Menu opened={open} onChange={setOpen} size="sm">
      <Menu.Target>
        <ActionIcon isChecked={open}>
          <IconDotsVertical />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {items.map((item) => (
          <Menu.Item
            key={item.title}
            onClick={item.onClick}
            disabled={item.disabled}
          >
            {item.title}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};
